import immutable from 'immutable'

const initialState = immutable.Map({})

/* Types */
export const ACTION_TEST = 'ACTION_TEST'

/* Reducer */
export default (state = initialState, action) => {
	switch (action.type) {
		case ACTION_TEST:
			return action.flag;
		default:
			return state;
	}
};

/* Action Creators */




// WEBPACK FOOTER //
// ./src/modules/Home/index.js